module.exports = __webpack_public_path__ + "static/media/download.df151bfe.jpg";